const required = value => {
  if (value || typeof value === 'number') {
    return undefined;
  }
  return 'Required';
};
export default required;
